module.exports = "/_next/static/images/MSU-f485c2e4dabc7e5ff4450ec15f238460.png";